/**
* 模版
**/ 

<template>
    <div style="width: 1200px; margin: auto">
        <div class="welcometop">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="welcometop_left">
                        <h3>欢迎来到诺安应急消防产品服务平台</h3>
                        <p>若您还没有填写入驻申请资料,<br/>
                            请点击“我要入驻”进行入驻资料填写<br/>
                            若您的店铺资料已经填写<br/>
                            请点击“店铺详情”进行详细的资料填写<br/>
                        </p>
                         
                         <el-button size="small" @click="$router.push('/merchantTypeSelect')">我要入驻</el-button>
                        <el-button size="small" v-if="userInfo.type==1"><a :href="$baseUrl" target="_blank">店铺详情</a></el-button>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="welcometop_right">
                        <el-image :src="logoimg==''?require('@/assets/img/bigbackground.png'):logoimg"></el-image>
                        <!-- <el-image :src="require('@/assets/img/bigbackground.png')"></el-image> -->
                        <!-- ceshi.xunyoutest.com/account/static/src/default/images/login-slide.png -->
                    </div>                
                </el-col>
            </el-row>
        </div>
        <div class="welcomeTabs" v-loading="loading">
            <el-tabs type="border-card">
                <el-tab-pane :label="item.title" v-for="(item,index) in agreementThreelists" :key="index">
                    <p v-html="item.content"></p>
                </el-tab-pane>
                <!-- <el-tab-pane label="招商规则1">
                    招商规则2
                </el-tab-pane>
                <el-tab-pane label="招商规则2">
                    招商规则3
                </el-tab-pane> -->
            </el-tabs>
        </div>
    </div>
</template>

<script>
// // 导入组件
import {agreementThreelist,pageConfigImg } from "@/api/xunyou";
// 导出模块
export default {
  // 模块名字
  name: "",
  // 模块数据
  data() {
    //数据  
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        loading:false,
        agreementThreelists:[],
        logoimg:'',
    };
  },
  // 注册组件
  components: {
    // headerComponent
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  mounted(){
      this.getagreementThreelist()
      this.getpageConfigImg()
  },
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    //   获取图片
    getpageConfigImg() {
      pageConfigImg()
        .then((res) => {
            if(res.code == 0){
                this.logoimg = res.rows[0].configValue
            }else{
                 this.$message.error(res.msg);
            }
        })
        .catch((err) => {
          this.$message.error("查询图片，请稍后再试！");
        });
    },
    // agreementThreelist
     // tab列表查询
    getagreementThreelist() {
      console.log("tab列表查询");
      this.loading = true;
      agreementThreelist({
        type:1 // 1:店铺；2.会员；3：供应商
      })
        .then((res) => {
          //   if (res.code == 0) {
          console.log("res", res);
          this.loading = false;
          this.agreementThreelists = res.data
         
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询招商规则失败，请稍后再试！");
        });
    },
  },
};
</script>
<style scoped lang='less'>
.welcometop {
    background-color: rgb(241, 165, 149);
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 25px;
    box-sizing: border-box;
    .welcometop_left {
        padding: 10px 25px;
        background-color: rgba(0,0,0,0.2);
        color: #fff;
        h3{
            font-size: 18px;
        }
        p{
            line-height: 24px;
            margin: 10px 0;
        }
        /deep/.el-button:focus, .el-button:hover {
            color: #e4393c;
            border-color: #e4393c;
        }
    }
    .welcometop_right{
        .el-image{
            height: 195px;
        }
    }    
}
.welcomeTabs{
        /deep/.el-tabs--border-card {
            border: none !important;
            box-shadow:none !important;
        }
        /deep/.el-tabs--border-card>.el-tabs__header {
            background-color:#f7f8f8 !important;
            border-bottom: none !important
        }

    }

</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/welcomesystem.vue